/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './ChevronIcon.style';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';

import svg from './chevron.svg';

export type Props = {
  className?: string,
  title?: string,
  left?: boolean,
  right?: boolean,
  up?: boolean,
  down?: boolean,
};

const useStyles = createUseThemeStyles(styles);

const ChevronIcon = ({
  className,
  title,
  right,
  up,
  down,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  const rootClasses = classNames(classes.root, className, {
    [classes['root-right']]: right,
    [classes['root-up']]: up,
    [classes['root-down']]: down,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return <BaseIcon className={rootClasses} svg={svg} title={title} />;
};

export default React.memo<Props>(ChevronIcon);
